function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { productDetailApi, categoryApi } from '@/api/store';
import { shippingTemplatesList } from '@/api/logistics';
import { goodDesignList } from "@/api/systemGroup";
import * as systemConfigApi from '@/api/systemConfig';
var defaultObj = {
  image: '',
  sliderImages: [],
  storeName: '',
  storeInfo: '',
  keyword: '',
  cateIds: [],
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  isBenefit: false,
  isNew: false,
  isGood: false,
  isHot: false,
  isBest: false,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    barCode: '',
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  isSub: false,
  content: '',
  specType: false,
  id: 0,
  couponIds: [],
  coupons: [],
  activity: ['默认', '秒杀', '砍价', '拼团']
};
var objTitle = {
  price: {
    title: '售价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
export default {
  name: 'ProductDetailView',
  props: {
    bizType: {
      default: null,
      type: Number
    }
  },
  data: function data() {
    return {
      fullscreenLoading: false,
      customConfig: {},
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      merCateList: [],
      shippingList: [],
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      manyTabTit: {},
      manyTabDate: {},
      grid2: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      recommend: [],
      attrInfo: {},
      isAttr: false
    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, this.customConfig.mallType == 1 ? defaultObj.attrValue[0] : {
        price: 0,
        stock: 0
      });
      delete obj.image;
      return obj;
    },
    activeRecommends: function activeRecommends() {
      var active = [];
      if (this.formValidate.isGood) {
        var item = this.recommend.find(function (r) {
          return r.value === 'isGood';
        });
        if (item) active.push(item);
      }
      if (this.formValidate.isBenefit) {
        var _item = this.recommend.find(function (r) {
          return r.value === 'isBenefit';
        });
        if (_item) active.push(_item);
      }
      if (this.formValidate.isBest) {
        var _item2 = this.recommend.find(function (r) {
          return r.value === 'isBest';
        });
        if (_item2) active.push(_item2);
      }
      if (this.formValidate.isNew) {
        var _item3 = this.recommend.find(function (r) {
          return r.value === 'isNew';
        });
        if (_item3) active.push(_item3);
      }
      if (this.formValidate.isHot) {
        var _item4 = this.recommend.find(function (r) {
          return r.value === 'isHot';
        });
        if (_item4) active.push(_item4);
      }
      return active;
    }
  },
  watch: {
    'formValidate.attr': {
      handler: function handler(val) {
        if (this.formValidate.specType && this.isAttr) this.watCh(val);
      },
      immediate: false,
      deep: true
    }
  },
  created: function created() {
    var _this = this;
    this.getInfo();
    this.getCategorySelect();
    this.getShippingList();
    this.getGoodsType();
    systemConfigApi.configInfo({
      id: "147"
    }).then(function (data) {
      _this.customConfig = data;
      if (_this.customConfig.mallType == 2) {
        _this.formThead = Object.assign({}, {
          price: {
            title: '售价'
          },
          stock: {
            title: '库存'
          }
        });
        console.log('this..');
        _this.OneattrValue = [Object.assign({}, {
          price: 0,
          stock: 0
        })];
        _this.ManyAttrValue = [Object.assign({}, {
          price: 0,
          stock: 0
        })];
      }
    });
  },
  methods: {
    // 获取商品详情
    getInfo: function getInfo() {
      var _this2 = this;
      this.fullscreenLoading = true;
      productDetailApi(this.$route.params.id).then(function (res) {
        var info = res;
        var categoryIds = info.categoryIds || info.cateId || '';
        var sliderRaw = info.sliderImages != null ? info.sliderImages : info.sliderImage;
        var specList = info.specList || info.attr || [];
        var skuList = info.skuList || info.attrValue || [];
        var specMode = !!(info.specMode != null ? info.specMode : info.specType);
        var parseJson = function parseJson(val, fallback) {
          if (val == null || val === '') return fallback;
          if (typeof val !== 'string') return val;
          try {
            return JSON.parse(val);
          } catch (e) {
            return fallback;
          }
        };
        var normalizeSku = function normalizeSku(val) {
          var row = _objectSpread({}, val);
          if (row.image) row.image = _this2.$selfUtil.setDomain(row.image);
          if (row.marketPrice != null && row.otPrice == null) row.otPrice = row.marketPrice;
          var rawMap = row.specMap != null ? row.specMap : row.attrValue;
          row.attrValue = parseJson(rawMap, {}) || {};
          return row;
        };
        _this2.formValidate = {
          image: _this2.$selfUtil.setDomain(info.image || info.mainImage || ''),
          sliderImage: typeof sliderRaw === 'string' ? sliderRaw : JSON.stringify(sliderRaw || []),
          sliderImages: [],
          storeName: info.productName || info.storeName,
          storeInfo: info.productIntro || info.storeInfo,
          keyword: info.keywords || info.keyword,
          cateIds: categoryIds ? String(categoryIds).split(',') : [],
          unitName: info.unit || info.unitName,
          sort: info.sort,
          isShow: info.publishStatus != null ? info.publishStatus : info.isShow,
          isBenefit: info.isDiscount != null ? info.isDiscount : info.isBenefit,
          isNew: info.isNew,
          isGood: info.isHighQuality != null ? info.isHighQuality : info.isGood,
          isHot: info.isHot,
          isBest: info.isRecommend != null ? info.isRecommend : info.isBest,
          tempId: info.freightTemplateId != null ? info.freightTemplateId : info.tempId,
          attr: [],
          attrValue: [],
          selectRule: info.selectRule,
          isSub: info.commissionSingle != null ? info.commissionSingle : info.isSub,
          content: _this2.$selfUtil.replaceImgSrcHttps(info.content),
          specType: specMode,
          id: info.id,
          giveIntegral: info.giveIntegral,
          ficti: info.fictitiousSales != null ? info.fictitiousSales : info.ficti,
          coupons: info.coupons,
          couponIds: info.couponIds,
          activity: Array.isArray(info.activity) ? info.activity : info.activityStr ? info.activityStr.split(',') : ['默认', '秒杀', '砍价', '拼团']
        };
        var imgs = parseJson(sliderRaw, []);
        if (!Array.isArray(imgs) && imgs && _typeof(imgs) === 'object') {
          imgs = Object.keys(imgs).map(function (i) {
            return imgs[i];
          });
        }
        if (!Array.isArray(imgs)) imgs = [];
        _this2.formValidate.sliderImages = imgs.map(function (i) {
          return _this2.$selfUtil.setDomain(i);
        });
        if (specMode) {
          _this2.formValidate.attr = (specList || []).map(function (item) {
            return {
              id: item.id,
              attrName: item.specName || item.attrName,
              attrValue: String(item.specValues || item.attrValues || '').split(',').filter(Boolean)
            };
          });
          _this2.ManyAttrValue = (skuList || []).map(normalizeSku);
          _this2.ManyAttrValue.forEach(function (val) {
            _this2.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
          });
          _this2.formValidate.attrValue = _this2.ManyAttrValue;
          var manyAttr = _this2.attrFormat(_this2.formValidate.attr);
          if (manyAttr.length !== _this2.ManyAttrValue.length) {
            _this2.isAttr = false;
          } else {
            _this2.isAttr = true;
          }
          var tmp = {};
          var tmpTab = {};
          _this2.formValidate.attr.forEach(function (o, i) {
            tmp[o.attrName] = {
              title: o.attrName
            };
            tmpTab[o.attrName] = '';
          });
          _this2.formValidate.attrValue.forEach(function (item) {
            for (var attrValueKey in item.attrValue) {
              item[attrValueKey] = item.attrValue[attrValueKey];
            }
          });
          _this2.manyTabTit = tmp;
          _this2.manyTabDate = tmpTab;
          _this2.formThead = Object.assign({}, _this2.formThead, tmp);
        } else {
          _this2.OneattrValue = (skuList || []).map(normalizeSku);
          _this2.formValidate.attr = [];
        }
        _this2.fullscreenLoading = false;
      }).catch(function (res) {
        _this2.fullscreenLoading = false;
        _this2.$message.error(res.message);
      });
    },
    // 商品分类
    getCategorySelect: function getCategorySelect() {
      var _this3 = this;
      categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this3.merCateList = _this3.filerMerCateList(res);
      });
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }
        item.label = item.name;
        return item;
      });
    },
    // 运费模板
    getShippingList: function getShippingList() {
      var _this4 = this;
      shippingTemplatesList({
        page: 1,
        limit: 9999
      }).then(function (res) {
        _this4.shippingList = res.recordList;
      });
    },
    // 商品推荐类型
    getGoodsType: function getGoodsType() {
      var _this5 = this;
      goodDesignList({
        gid: 70
      }).then(function (response) {
        var list = response.list;
        var arr = [],
          arr1 = [];
        var listArr = [];
        var typeLists = [{
          name: '',
          value: 'isHot',
          type: '2'
        }, {
          name: '',
          value: 'isBenefit',
          type: '4'
        }, {
          name: '',
          value: 'isBest',
          type: '1'
        }, {
          name: '',
          value: 'isNew',
          type: '3'
        }];
        list.forEach(function (item) {
          var obj = {};
          obj.value = JSON.parse(item.value);
          obj.id = item.id;
          obj.gid = item.gid;
          obj.status = item.status;
          arr.push(obj);
        });
        arr.forEach(function (item1) {
          var obj1 = {};
          obj1.name = item1.value.fields[1].value;
          obj1.status = item1.status;
          obj1.type = item1.value.fields[3].value;
          arr1.push(obj1);
        });
        typeLists.forEach(function (item) {
          arr1.forEach(function (item1) {
            if (item.type == item1.type) {
              listArr.push({
                name: item1.name,
                value: item.value,
                type: item.type
              });
            }
          });
        });
        _this5.recommend = listArr;
      });
    },
    // 格式化分类显示
    formatCateIds: function formatCateIds(cateIds) {
      var _this6 = this;
      if (!cateIds || !Array.isArray(cateIds)) return '';
      var findCateName = function findCateName(id, list) {
        var _iterator = _createForOfIteratorHelper(list),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (item.id == id) return item.name;
            if (item.child) {
              var name = findCateName(id, item.child);
              if (name) return name;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return '';
      };
      return cateIds.map(function (id) {
        return findCateName(id, _this6.merCateList);
      }).filter(function (name) {
        return name;
      }).join(' / ');
    },
    // 格式化运费模板显示
    formatTempId: function formatTempId(tempId) {
      if (!tempId) return '';
      var template = this.shippingList.find(function (item) {
        return item.id == tempId;
      });
      return template ? template.name : '';
    },
    // 返回列表页，不刷新列表数据
    goBack: function goBack() {
      var listPath = this.$route.meta && this.$route.meta.activeMenu;
      if (!listPath) {
        this.$router.go(-1);
        return;
      }
      this.$store.dispatch('tagsView/delView', this.$route);
      this.$router.push({
        path: listPath
      });
    },
    // 多规格处理相关方法
    watCh: function watCh(val) {
      var _this7 = this;
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.ManyAttrValue = this.attrFormat(val);
      this.ManyAttrValue.forEach(function (val, index) {
        var key = Object.values(val.attrValue).sort().join('/');
        if (_this7.attrInfo[key]) _this7.ManyAttrValue[index] = _this7.attrInfo[key];
      });
      this.attrInfo = [];
      this.ManyAttrValue.forEach(function (val) {
        _this7.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);
      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            if (!data) return;
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);
                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    cost: 0,
                    otPrice: 0,
                    stock: 0,
                    barCode: '',
                    weight: 0,
                    volume: 0,
                    brokerage: 0,
                    brokerage_two: 0
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });
                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }
                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                cost: 0,
                otPrice: 0,
                stock: 0,
                barCode: '',
                weight: 0,
                volume: 0,
                brokerage: 0,
                brokerage_two: 0,
                attrValue: _defineProperty({}, v['attrName'], vv)
              };
              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }
        return res;
      }
    }
  }
};